import React, { useEffect } from "react";
import "moment-timezone";
import { useTranslation } from "react-i18next";
import AppInput from "components/ui/AppInput.jsx";
import AppSwitch from "components/ui/AppSwitch.jsx";
import AppHeading1 from "components/ui/AppHeading1.jsx";
import AppSimpleText from "components/ui/AppSimpleText.jsx";


const LoyaltyForm = ({
  onsubmit,
  register,
  errors,
  watch,
  trigger,
  setValue,
}) => {
  const { t } = useTranslation();
  const isLoyaltyActive = watch("isLoyaltyActive");
  const isWelcomeBonusActive = watch("welcomeBonus.isActive");
  const cashbackPercentage = watch("specificToDelivery.cashbackPercentage");
  const redeemablePercentagePerOrder = watch("redeemablePercentagePerOrder");
  const maxRedeemableValuePerOrder = watch("maxRedeemableValuePerOrder");
  const welcomeBonusValue = watch("welcomeBonus.value");

  useEffect(() => {
    register("isLoyaltyActive");
    register("specificToDelivery.cashbackPercentage");
    register("redeemablePercentagePerOrder");
    register("maxRedeemableValuePerOrder");
    register("welcomeBonus.isActive");
    register("welcomeBonus.value");
  }, [register]);

  useEffect(() => {
    trigger("welcomeBonus.value");
  }, [isWelcomeBonusActive, trigger]);

  const handleValues = (key, value) => {
    setValue(key, value, {
      shouldDirty: true,
      shouldValidate: true,
    });
  };

  return (
    <form id="loyalty-form" onSubmit={onsubmit}>
      <div className="w-full md:w-10/12 lg:w-full">
        <div className="py-2">
          <AppSwitch
            label={
              isLoyaltyActive
                ? t("Loyalty Activated")
                : t("Loyalty Deactivated")
            }
            checked={!!isLoyaltyActive}
            onChange={(checked) => handleValues("isLoyaltyActive", checked)}
          />
        </div>

        <div className="lg:w-full">
          <AppHeading1>{t("Earning")}</AppHeading1>
          <AppSimpleText>
            {t("How much credit your customers get with each order")}
          </AppSimpleText>
          <div className="py-2 w-full md:w-1/2 pr-2">
            <AppInput
              label={t("Cashback (%)")}
              placeholder="50"
              value={cashbackPercentage ?? ""}
              error={errors?.specificToDelivery?.cashbackPercentage?.message}
              onChange={(e) =>
                handleValues("specificToDelivery.cashbackPercentage", e.target.value)
              }
            />
          </div>

          <div className="my-8">
            <AppHeading1>{t("Spending")}</AppHeading1>
            <AppSimpleText>
              {t(
                "Set the maximum limits for redeeming credit. The system will always apply the lowest."
              )}
            </AppSimpleText>

            <div className="flex flex-col md:flex-row gap-2">
              <div className="py-1 me-0 md:me-1 lg:w-full md:w-1/2">
                <AppInput
                  label={t("Redeemable(%)")}
                  placeholder="30"
                  value={redeemablePercentagePerOrder ?? ""}
                  error={errors?.redeemablePercentagePerOrder?.message}
                  onChange={(e) =>
                    handleValues("redeemablePercentagePerOrder", e.target.value)
                  }
                />
              </div>
              <div className="py-1 lg:w-full md:w-1/2">
                <AppInput
                  label={t("Max redeemable value")}
                  placeholder="10"
                  value={maxRedeemableValuePerOrder ?? ""}
                  error={errors?.maxRedeemableValuePerOrder?.message}
                  onChange={(e) =>
                    handleValues("maxRedeemableValuePerOrder", e.target.value)
                  }
                />
              </div>
            </div>
          </div>

          <AppHeading1>{t("Loyalty Welcome Bonus")}</AppHeading1>
          <AppSimpleText>
            {t("Give your first time customers a cashback bonus.")}
          </AppSimpleText>

          <div className="py-2">
            <AppSwitch
              label={t("Welcome Bonus Credit")}
              checked={!!isWelcomeBonusActive}
              onChange={(checked) => handleValues("welcomeBonus.isActive", checked)}
            />
          </div>

          <div className="py-2 w-full md:w-1/2 pr-2">
            <AppInput
              label={t("Credit value")}
              placeholder="50"
              value={welcomeBonusValue ?? ""}
              disabled={!isWelcomeBonusActive}
              error={errors?.welcomeBonus?.value?.message}
              onChange={(e) => handleValues("welcomeBonus.value", e.target.value)}
            />
          </div>
        </div>
      </div>
    </form>
  );
};

export default LoyaltyForm;
